<div class="modulePicker mr-2" [matMenuTriggerFor]="modulesMenu" [ngClass]="{'cursor-pointer-none': !isAppOnline}">
  <button
    mat-icon-button
    data-testId="open-module-picker"
    class="button--square button--small"
    [disabled]="!isAppOnline"
  >
    <mat-icon class="icon--large" svgIcon="apps"></mat-icon>
  </button>
  <mat-menu #modulesMenu="matMenu" class="m-2 moduleMenu" xPosition="before">
    <ng-template matMenuContent>
      <ng-container *ngIf="modules?.length; else noModulesTemplate">
        <div class="modules">
          <!-- Modules with access -->
          <ng-container *ngFor="let module of modulesWithAccess; trackBy: trackModule">
            <div
              class="modules_item"
              mat-menu-item
              [attr.data-testId]="'select-' + module.name"
              (click)="onModuleSelected(module)"
            >
              <div class="moduleDetails">
                <img [src]="module.favIconUrl" />
                <div>
                  <span>{{module.name}}</span>
                  <div class="text-muted">
                    <span>{{module.description}}</span>
                  </div>
                </div>
              </div>

              <div class="activeModule">
                <mat-icon svgIcon="check"></mat-icon>
                <span>Active</span>
              </div>
            </div>
          </ng-container>

          <!-- Core module -->
          <div class="modules_item" mat-menu-item (click)="onModuleSelected(coreModule)">
            <div class="moduleDetails">
              <img [src]="coreModule.favIconUrl" />
              <div>
                <span>{{coreModule.name}}</span>
                <div class="text-muted">
                  <span>{{coreModule.description}}</span>
                </div>
              </div>
            </div>

            <div class="activeModule">
              <mat-icon svgIcon="check"></mat-icon>
              <span i18n="@@shared.modulePicker.txtActive">Active</span>
            </div>
          </div>

          <!-- Modules without access -->
          <ng-container *ngFor="let module of modulesWithoutAccess; trackBy: trackModule">
            <div class="modules_item" mat-menu-item (click)="onModuleSelected(module)">
              <div class="moduleDetails">
                <img [src]="module.favIconUrl" />
                <div>
                  <span>{{module.name}}</span>
                  <div class="text-muted">
                    <span>{{module.description}}</span>
                  </div>
                </div>
              </div>

              <div class="noAccessModule">
                <span i18n="@@shared.modulePicker.txtFindOutMore">Find out more</span>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <ng-template #noModulesTemplate>
        <div class="text-muted p-3">
          <i i18n="@@shared.modulePicker.txtNoApps">No apps available</i>
        </div>
      </ng-template>
    </ng-template>
  </mat-menu>
</div>
